import { useEffect, useState } from 'react'

export const useMediaQuery = (query: string): boolean => {
    const [matches, setMatches] = useState(false)

    useEffect(() => {
        const list = window.matchMedia(query)
        const update = () => setMatches(list.matches)

        update()
        list.addEventListener('change', update)

        return () => list.removeEventListener('change', update)
    }, [query])

    return matches
}
